import React from "react";
import { TextField, InputAdornment } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchIcon from "@material-ui/icons/Search";
import useStyles from "./FilterBar.styles";

export default function FilterBar({
  search = "",
  onSearchChange,
  canal = "",
  onCanalChange,
  canalOptions = [],
  origem = "",
  onOrigemChange,
  origemOptions = [],
}) {
  const classes = useStyles();

  const findOption = (options, value) =>
    options.find((option) => option.value === value) || null;

  return (
    <div className={classes.root}>
      <TextField
        className={`${classes.field} ${classes.search}`}
        fullWidth
        variant="outlined"
        placeholder="Busque por número do pedido ou nome do cliente"
        value={search}
        onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />

      <Autocomplete
        size="small"
        className={classes.field}
        options={canalOptions}
        getOptionLabel={(option) => option.label}
        getOptionSelected={(option, selected) =>
          option.value === selected.value
        }
        value={findOption(canalOptions, canal)}
        onChange={(_, option) =>
          onCanalChange && onCanalChange(option ? option.value : "")
        }
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            variant="outlined"
            placeholder="Canal de Venda"
          />
        )}
      />

      <Autocomplete
        size="small"
        className={classes.field}
        options={origemOptions}
        getOptionLabel={(option) => option.label}
        getOptionSelected={(option, selected) =>
          option.value === selected.value
        }
        value={findOption(origemOptions, origem)}
        onChange={(_, option) =>
          onOrigemChange && onOrigemChange(option ? option.value : "")
        }
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            variant="outlined"
            placeholder="Origem"
          />
        )}
      />
    </div>
  );
}
